import React from 'react'
import classNames from 'classnames'
import FormLabel from './form-label'
import FieldErrors from '../field-errors'

const Checkbox = React.forwardRef(({
  name,
  label,
  error,
  showLabel = true,
  readOnly = false,
  ...otherProps
}, ref) => {
  return (
    <div className='flex items-center'>
      <input
        id={name}
        ref={ref}
        className='h-4 accent-purple-60 readonly:bg-gray-10'
        type='checkbox'
        name={name}
        disabled={readOnly}
        {...otherProps}
      />
      <FormLabel
        className={classNames('ml-3', { 'text-gray-30': otherProps.disabled })}
        name={name} show={showLabel} value={label}
      />
      <FieldErrors error={error} />
    </div>
  )
})

export default Checkbox
